import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const AdminAnalytics = ({ stats: propStats }) => {
  const [localStats, setLocalStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (propStats) {
      setLocalStats(propStats);
      setLoading(false);
      return;
    }
    const fetchAnalytics = async () => {
      try {
        const token = localStorage.getItem('token');
        const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');
        const res = await fetch(`${API_URL}/admin/analytics`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) throw new Error('Error al cargar analíticas');
        const data = await res.json();
        setLocalStats(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchAnalytics();
  }, [propStats]);

  if (loading) return <div style={{ padding: '1rem', color: 'var(--text-muted)' }}>Cargando analíticas...</div>;
  if (error) return <div style={{ padding: '1rem', color: '#ef4444' }}>{error}</div>;
  if (!localStats) return null;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', height: '100%' }}>
        <div className="glass-panel" style={{ padding: '1.5rem' }}>
          <h4 style={{ marginTop: 0, color: 'var(--text-muted)' }}>Top Secciones Visitadas</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {localStats.topPages.length === 0 && <li style={{ color: 'var(--text-secondary)' }}>Sin datos recientes</li>}
            {localStats.topPages.map((page, i) => (
              <li key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                <span style={{ color: 'white' }}>{page.path}</span>
                <span style={{ color: 'var(--health-cyan)', fontWeight: 'bold' }}>{page.count}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="glass-panel" style={{ padding: '1.5rem' }}>
          <h4 style={{ marginTop: 0, color: 'var(--text-muted)', marginBottom: '1rem' }}>Uso de IA por Tipo</h4>
          {localStats.ai.breakdownByType.length === 0 ? (
            <div style={{ color: 'var(--text-secondary)' }}>Sin datos recientes</div>
          ) : (
            <div style={{ width: '100%', height: '200px' }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={localStats.ai.breakdownByType} margin={{ top: 5, right: 5, left: -25, bottom: 5 }}>
                  <XAxis dataKey="type" stroke="rgba(255,255,255,0.4)" tick={{ fill: 'rgba(255,255,255,0.6)', fontSize: 11 }} tickFormatter={(val) => val.replace(/_/g, ' ').substring(0,10)} />
                  <YAxis stroke="rgba(255,255,255,0.4)" tick={{ fill: 'rgba(255,255,255,0.6)', fontSize: 11 }} />
                  <Tooltip 
                    contentStyle={{ backgroundColor: 'rgba(17, 24, 39, 0.9)', borderColor: 'rgba(255,255,255,0.1)', borderRadius: '8px' }}
                    itemStyle={{ color: 'var(--health-green)' }}
                    formatter={(value) => [value, 'Peticiones']}
                    labelFormatter={(label) => String(label).replace(/_/g, ' ').toUpperCase()}
                  />
                  <Bar dataKey="count" fill="var(--health-green)" radius={[4, 4, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
      </div>
  );
};

export default AdminAnalytics;
